import { CurrencyList } from '../../../common/enums/Currency';
import { IOnInit } from 'angular';
import {ReportsRepo} from '../../../reports/reports.repo'
import * as moment from 'moment'

class CustodianReportDialog implements IOnInit{

  public clientPortfolios;

  public reportDate;

  public currencyList = CurrencyList;

  private attachmentsControl: HTMLInputElement;
  public files: FileList;

  public selectedFile;

  public selectedCurrency;

  public selectedPortfolio;

  /** @ngInject */
  constructor(private $mdDialog: angular.material.IDialogService, private notifyjs, private $scope: angular.IScope,
     private $timeout: angular.ITimeoutService, private reportsRepo : ReportsRepo) {

  }

  $onInit(){
    let that = this;

    this.$timeout(() => {
      that.attachmentsControl = document.getElementById('attachments') as HTMLInputElement;
      that.attachmentsControl.addEventListener('change', that.onFilesSelected.bind(that));
    },1000);

  }

  private onFilesSelected(event) {
    this.files = event.target.files;
    this.$scope.$apply();
  }

  cancel = () => {
    this.$mdDialog.hide();
  }

  public uploadReport = () => {
    const formData = new FormData();

    formData.append('portfolioId', this.selectedPortfolio)
    formData.append('currency', this.selectedCurrency)

    let reportDate = moment(this.reportDate).endOf('month').format("YYYY-MM-DD")
    formData.append('reportDate', reportDate)

    Array.from(this.attachmentsControl.files).forEach(file => formData.append('attachment', file))

    this.reportsRepo.uploadCustodianReport(formData)
      .then(() => {
        this.$mdDialog.hide(true);
      });
  }


  isFormValid = () => {
    return this.selectedCurrency && this.selectedPortfolio && this.attachmentsControl.files.length > 0
  }




}


export const custodianReportDialog: angular.IComponentOptions = {
  template: require('./custodianReport.dialog.html'),
  controller: CustodianReportDialog,
  bindings : {
    clientPortfolios : "<",
    reportDate : "<"
  }
}



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/reportManagement/custodianReportDialog/custodianReport.dialog.ts